const fixDutyFine = {
  DefiniteTime: {
    zh: '定责时间',
    en: 'Definite Time',
    pu: 'Tempo de Responsabilidade'
  },
  DefiniteType: {
    zh: '定责类型',
    en: 'Definite Type',
    pu: 'Tipo de Responsabilidade'
  },
  StolenOrRobbed: {
    zh: '被偷或被抢',
    en: 'Stolen or Robbed',
    pu: 'Roubado ou assaltato'
  },
  ComplaintWorkOrderTimeoutNotReplied: {
    zh: '投诉工单-超时未回复',
    en: 'Complaint work order - Timeout not replied',
    pu: 'Trabalho de reclamação - Tempo esgotado não respondido'
  },
  SocialMediaUpgradeComplaint: {
    zh: '社媒升级投诉',
    en: 'Social media upgrade complaint',
    pu: 'Reclamação de upgrade de mídia social'
  },
  PODNotQualified: {
    zh: 'POD不合格',
    en: 'POD not qualified',
    pu: 'POD não qualificado'
  },
  DefiniteLink: {
    zh: '定责环节',
    en: 'Definite link',
    pu: 'Link de Responsabilidade'
  },
  ResponsibleParty: {
    zh: '责任方',
    en: 'Responsible party',
    pu: 'Parte responsável'
  },
  ModifyResponsibleBranch: {
    zh: '修改责任网点',
    en: 'Modify responsible branch',
    pu: 'Modificar filial responsável'
  },
  Item: {
    zh: '项',
    en: 'Item',
    pu: 'itens'
  },
  Damage: {
    zh: '破损',
    en: 'Damage',
    pu: 'danificados'
  },
  PODIrregular: {
    zh: 'POD不规范',
    en: 'POD irregular',
    pu: 'POD irregular'
  },
  ResponsibleLink: {
    zh: '责任环节',
    en: 'Responsible link',
    pu: 'Link de Responsabilidade'
  },
  EstimatedPenaltyAmount: {
    zh: '预计扣罚金额',
    en: 'Estimated penalty amount',
    pu: 'Valor estimado de multa'
  },
  LatestTrackingBranch: {
    zh: '最新轨迹网点',
    en: 'Latest tracking branch',
    pu: 'Último ponto de rastreio'
  },
  SecondaryNewTrackingTime: {
    zh: '次新轨迹时间',
    en: 'Secondary new tracking time',
    pu: 'Tempo de rastreio de segunda nova'
  },
  SecondaryNewTrackingContent: {
    zh: '次新轨迹内容',
    en: 'Secondary new tracking content',
    pu: 'Conteúdo de rastreio de segunda nova'
  },
  SecondaryNewTrackingBranch: {
    zh: '次新轨迹网点',
    en: 'Secondary new tracking branch',
    pu: 'Filial de rastreio de segunda nova'
  },
  ResponsibleBranch: {
    zh: '责任网点',
    en: 'Responsible branch',
    pu: 'Filial responsável'
  },
  TotalModification: {
    zh: '总共修改',
    en: 'Total modification',
    pu: 'Total de modificação'
  },
  ModificationFailedOrderNumber: {
    zh: '修改失败单号',
    en: 'Modification failed order number',
    pu: 'Número de ordem de modificação falhou'
  },
  Only2000PiecesImport: {
    zh: '每次仅导入2000条',
    en: 'Only 2000 pieces are imported at a time',
    pu: 'Importar apenas 2000 itens de cada vez'
  },
  ImportFailedOrderNumber: {
    zh: '导入失败单号',
    en: 'Import failed order number',
    pu: 'Número de ordem de importação falhou'
  },
  frontEndCollection: {
    zh: '前端揽收',
    en: 'Front-end Collection',
    pu: 'Coleta no Front-end'
  },
  hubOperation: {
    zh: 'HUB操作',
    en: 'HUB Operation',
    pu: 'Operação no HUB'
  },
  collectionTransport: {
    zh: '揽收运输',
    en: 'Collection Transport',
    pu: 'Transporte de Coleta'
  },
  glpUnloading: {
    zh: 'GLP卸车',
    en: 'GLP Unloading',
    pu: 'Descarregamento GLP'
  },
  delayedProcess: {
    zh: '延误的流程',
    en: 'Delayed Process',
    pu: 'Processo Atrasado'
  },
  estimatedOperationDuration: {
    zh: '预计操作时长(H)',
    en: 'Estimated Operation Duration(H)',
    pu: 'Duração Estimada da Operação(H)'
  },
  actualOperationDuration: {
    zh: '实际操作时长(H)',
    en: 'Actual Operation Duration(H)',
    pu: 'Duração Real da Operação(H)'
  },
  delayDuration: {
    zh: '延误时长(H)',
    en: 'Delay Duration(H)',
    pu: 'Duração do Atraso(H)'
  },
  DefinitePerson: {
    zh: '定责人',
    en: 'Definite person',
    pu: 'Pessoa de Responsabilidade'
  },
  selectTimeRange: {
    zh: '请选择查询时间范围',
    en: 'Please select the query time range',
    pu: 'Por favor selecione o intervalo de tempo da consulta'
  },
  modifyResponsibility: {
    zh: '修改定责',
    en: 'Modify Responsibility',
    pu: 'Modificar Responsabilidade'
  },
  selectResponsibleParty: {
    zh: '请选择责任方',
    en: 'Please select the responsible party',
    pu: 'Por favor selecione a parte responsável'
  },
  selectBeforeModify: {
    zh: '请先选择,再修改',
    en: 'Please select first, then modify',
    pu: 'Por favor selecione primeiro, depois modifique'
  },
  trunkLine: {
    zh: '干线',
    en: 'Trunk Line',
    pu: 'Linha Tronco'
  },
  reportTime: {
    zh: '上报时间',
    en: 'Report Time',
    pu: 'Hora do Relatório'
  },
  approvalTime: {
    zh: '审批时间',
    en: 'Approval Time',
    pu: 'Hora de Aprovação'
  },
  eventType: {
    zh: '事件类型',
    en: 'Event Type',
    pu: 'Tipo de Evento'
  },
  abnormalEvent: {
    zh: '异常事件',
    en: 'Abnormal Event',
    pu: 'Evento Anormal'
  },
  theftEvent: {
    zh: '盗抢事件',
    en: 'Theft/Robbery Event',
    pu: 'Evento de Roubo/Furto'
  },
  abnormalityType: {
    zh: '异常类型',
    en: 'Abnormality Type',
    pu: 'Tipo de Anormalidade'
  },
  pendingApproval: {
    zh: '待审批',
    en: 'Pending Approval',
    pu: 'Aprovação Pendente'
  },
  reportingRegion: {
    zh: '上报大区',
    en: 'Reporting Region',
    pu: 'Região de Relatório'
  },
  reportingPersonnel: {
    zh: '上报人员',
    en: 'Reporting Personnel',
    pu: 'Pessoal de Relatório'
  },
  reportedEvent: {
    zh: '上报事件',
    en: 'Reported Event',
    pu: 'Evento Reportado'
  },
  reportingTime: {
    zh: '上报时间',
    en: 'Reporting Time',
    pu: 'Hora de Relatório'
  },
  eventCategory: {
    zh: '事件类型',
    en: 'Event Category',
    pu: 'Categoria de Evento'
  },
  maxExportLimit: {
    zh: '单次最多导出1000个单号',
    en: 'Maximum 1000 tracking numbers per export',
    pu: 'Máximo de 1000 números de rastreamento por exportação'
  },
  abnormalityLevel: {
    zh: '异常等级',
    en: 'Abnormality Level',
    pu: 'Nível de Anormalidade'
  },
  affectedPackageCount: {
    zh: '影响包裹数量',
    en: 'Affected Package Count',
    pu: 'Contagem de Pacotes Afetados'
  },
  estimatedFinancialLoss: {
    zh: '预估资金损失(R$)',
    en: 'Estimated Financial Loss (R$)',
    pu: 'Perda Financeira Estimada (R$)'
  },
  casualtyCount: {
    zh: '伤亡人员数量',
    en: 'Casualty Count',
    pu: 'Contagem de Vítimas'
  },
  approver: {
    zh: '审批人',
    en: 'Approver',
    pu: 'Aprovador'
  },
  abnormalityDescription: {
    zh: '异常事件描述',
    en: 'Abnormality Description',
    pu: 'Descrição da Anormalidade'
  },
  hasPoliceReceipt: {
    zh: '是否有报警回执?',
    en: 'Has Police Receipt?',
    pu: 'Possui Recibo Policial?'
  },
  hasMDFE: {
    zh: '是否开具MDFE?',
    en: 'Has MDFE Issued?',
    pu: 'Foi Emitido MDFE?'
  },
  hasElectronicLock: {
    zh: '是否有电子锁?',
    en: 'Has Electronic Lock?',
    pu: 'Possui Fechadura Eletrônica?'
  },
  photos: {
    zh: '照片',
    en: 'Photos',
    pu: 'Fotos'
  },
  excludeFromTimeliness: {
    zh: '是否剔除时效?',
    en: 'Exclude from Timeliness?',
    pu: 'Excluir do Prazo?'
  },
  estimatedLossAmount: {
    zh: '预估损失金额',
    en: 'Estimated Loss Amount',
    pu: 'Valor Estimado da Perda'
  },
  eventApproval: {
    zh: '事件审批',
    en: 'Event Approval',
    pu: 'Aprovação de Evento'
  },
  viewDetails: {
    zh: '查看详情',
    en: 'View Details',
    pu: 'Ver Detalhes'
  },
  affectedPackageDetails: {
    zh: '影响包裹明细',
    en: 'Affected Package Details',
    pu: 'Detalhes dos Pacotes Afetados'
  },
  selectExcludeTimeliness: {
    zh: '请选择是否剔除时效',
    en: 'Please select whether to exclude from timeliness',
    pu: 'Por favor selecione se deseja excluir do prazo'
  },
  uploadImageLimit: {
    zh: '最多可上传6张图片.仅支持上传格式为(jpg、jpeg、png、gif)',
    en: 'Maximum 6 images can be uploaded. Only supports (jpg, jpeg, png, gif) formats',
    pu: 'Máximo de 6 imagens podem ser carregadas. Suporta apenas formatos (jpg, jpeg, png, gif)'
  },
  high: {
    zh: '高',
    en: 'High',
    pu: 'Alto'
  },
  medium: {
    zh: '中',
    en: 'Medium',
    pu: 'Médio'
  },
  low: {
    zh: '低',
    en: 'Low',
    pu: 'Baixo'
  },
  addPhotos: {
    zh: '添加照片',
    en: 'Add Photos',
    pu: 'Adicionar imagens'
  },
  uploadImages: {
    zh: '请上传图片',
    en: 'Please upload images',
    pu: 'Por favor carregue imagens'
  },
  imageUploadFailed: {
    zh: '上传图片失败',
    en: 'Image upload failed',
    pu: 'Falha no carregamento da imagem'
  },
  formatFile: {
    zh: '请上传图片格式的文件(jpg、jpeg、png、gif)',
    en: '',
    pu: 'Faca um upload de documento na forma de foto(jpg, jpeg, png, gif)'
  },
  max50ExportLimit: {
    zh: '单次最多导出500000个单号',
    en: 'Maximum 500000 tracking numbers per export',
    pu: 'Máximo de 500000 números de rastreamento por exportação'
  },
  searchMax10w: {
    zh: '单次查询最多10万条，已截取前10万条',
    en: '',
    pu: 'Máximo de 2.000 entradas para uma única consulta, as primeiras 2.000 entradas foram interceptadas'
  }
};
export { fixDutyFine };
